import { LuCopy, LuCopyCheck } from "react-icons/lu";

import fallbackBg from "shared/assets/fallback-bg.svg";
import PotWithTg from "shared/assets/pot-with-tg.svg?react";
import { useCopyToClipboard } from "shared/hooks/use-copy-to-clipboard";
import { Button } from "shared/ui/button";

type Props = {
  error: unknown;
  resetErrorBoundary: () => void;
};

export const Fallback = (props: Props) => {
  const { error, resetErrorBoundary } = props;
  const { copy, isCopied } = useCopyToClipboard();
  console.error({ error });
  const { name, message } = (() => {
    if (error instanceof Error) {
      return { name: error.name, message: error.message };
    }

    return { name: "Something went wrong", message: `${error}` };
  })();
  return (
    <div
      style={{
        backgroundImage: `url(${fallbackBg})`,
      }}
      className="flex h-full grow flex-col items-center justify-center bg-cover bg-center"
    >
      <PotWithTg className="grayscale-100" />
      <h1 className="mt-5 text-2xl leading-[120%] font-semibold">{name}</h1>
      <div className="text-balticSea/50 border-balticSea/15 mt-4 flex gap-x-3 rounded-xl border px-3.5 py-2.5">
        <p className="line-clamp-2 text-sm leading-[160%]">{message}</p>
        <button
          className="flex items-center justify-center outline-hidden"
          onClick={() => {
            copy(message);
          }}
        >
          {isCopied && <LuCopyCheck className="size-5" />}
          {!isCopied && <LuCopy className="size-5" />}
        </button>
      </div>

      <Button className="mt-8 h-10" onClick={resetErrorBoundary}>
        Retry
      </Button>
    </div>
  );
};
